<template>
  <div class="company-box">
    <div :class="'left-box ' + (compData ? '' : 'nodata')">
      <div class="item-wrapper">
        <div class="item-top">
          <i class="company-icon"></i>
          <div class="item-title YouSheTitle" :data-title="curData.companyName"></div>
        </div>
        <div
          class="item-content content-bg"
          v-if="compData"
          v-loading="loading"
          element-loading-background="rgba(0, 0, 0, 0.5)"
        >
          <div class="flex-between">
            <ul v-for="ul in dialogUlList">
              <li v-for="li in ul">
                <div class="li-label">{{ li.label }}</div>
                <div v-if="li.isTip">
                  <el-tooltip effect="dark" placement="top" v-if="compData[li.key] && compData[li.key].length > 6">
                    <div class="li-value">{{ compData[li.key] || '-' }}</div>
                    <div slot="content" style="width: 180px; line-height: 1.4">{{ compData[li.key] || '-' }}</div>
                  </el-tooltip>
                </div>
                <div v-else class="li-value">{{ compData[li.key] || '-' }}</div>
              </li>
            </ul>
          </div>
          <div class="ul-bottom">
            <div class="li-label">所属行业:</div>
            <div class="li-value">{{ compData.sshy }}</div>
          </div>
        </div>
      </div>
      <div v-if="compData" class="left-bottom">
        <TabList
          class="po"
          :list="tabList"
          :act="tabIndex"
          @clickItem="
            (item, i) => {
              tabIndex = i;
            }
          "
        ></TabList>
        <div class="item-wrapper">
          <div class="item-title" :data-title="tabList[tabIndex].label"></div>
          <div class="item-content" v-loading="loadingTB" element-loading-background="rgba(0, 0, 0, 0.5)">
            <ComTable :tableCol="tableCompCol" :tableData="tableData" :isPagination="false" />
          </div>
        </div>
      </div>
      <div v-else class="left-bottom nodata"></div>
    </div>
    <div class="right-box">
      <div class="item-wrapper">
        <div class="item-title" data-title="股东情况"></div>
        <div class="chart-con">
          <div class="pie-bg"></div>
          <div class="item-content" v-loading="loadingGD" element-loading-background="rgba(0, 0, 0, 0.5)">
            <v-chart ref="pie3D-gd" id="pie3D-gd" class="pie3D-gd" :options="chartOption" />
            <div :class="['chart-legend', { chart3d: tabIndex }]">
              <div class="legend-list">
                <div class="legend-item" v-for="(item, i) in chartData" :key="i">
                  <div class="name">
                    <span class="color" :style="{ 'background-color': colors3D[i] }"></span>
                    <span>
                      {{ item.name ? item.name : '-' }}
                    </span>
                  </div>
                  <span class="num">
                    {{ item.prop }}
                  </span>
                  <span class="unit">%</span>
                </div>
              </div>
              <div class="pager-box" v-if="pagerGD.total > 8">
                <i :class="['el-icon-caret-top', { dis: pagerGD.current <= 1 }]" @click="changePage(false)"></i>
                <div>
                  {{ pagerGD.current }}
                  <span> / {{ pagerGD.total }} </span>
                </div>
                <i
                  :class="['el-icon-caret-bottom', { dis: pagerGD.current >= pagerGD.total }]"
                  @click="changePage(true)"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabList from '../../../components/tabList';
import ComTable from '../../../components/ComTable';
import $ from 'jquery';
import drawPie3D from '../chartJs/pie3D';
import { getTime } from '@/utils/tool';
import echarts from 'echarts';
const colors3D = ['#00c9ff', '#0078ff', '#fcf5c2', '#58ecac'];

export default {
  name: 'CompModal',
  components: { TabList, ComTable },
  props: {
    year: {
      type: Number,
      default: 2023,
    },
    curData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      loading: true,
      loadingTB: true,
      loadingGD: true,
      colors3D,
      dataList: [
        {
          top: 1,
          companyName: 'TCL(集团)',
          city: '惠州市',
          type: '计算机、通...',
        },
        {
          top: 2,
          companyName: '比亚迪股份有限公司',
          city: '深圳市',
          type: '汽车制造业',
        },
        {
          top: 3,
          companyName: '顺丰控股有限公司',
          city: '惠州市',
          type: '邮政业',
        },
        {
          top: 4,
          companyName: '广东鼎龙实业集团 ...',
          city: '惠州市',
          type: '商务服务业',
        },
        {
          top: 5,
          companyName: '广东鼎龙实业集团 ...',
          city: '惠州市',
          type: '商务服务业',
        },
        {
          top: 6,
          companyName: '广东鼎龙实业集团 ...',
          city: '惠州市',
          type: '商务服务业',
        },
      ],
      listBox: null,
      scrollY: 0,
      tabList: [
        {
          key: 0,
          label: '行政许可',
        },
        {
          key: 1,
          label: '迁移情况',
        },
        {
          key: 2,
          label: '变更情况',
        },
        // {
        //   key: 3,
        //   label: '经营情况',
        // },
        {
          key: 3,
          label: '经营异常情况',
        },
      ],
      tabIndex: 0,
      chart: null,
      chartOption: null,
      chartData: null,
      compData: null,
      modalData: {},
      tableData: [],
      pager: {
        currentPage: 1,
        pageSize: 5,
        total: 0,
      },
      pagerGD: {
        currentPage: 1,
        pageSize: 8,
        total: 0,
      },
    };
  },
  watch: {
    year(n) {
      this.getData();
    },
    chartData(n) {
      this.pager.total = n?.length ? Math.ceil((n?.length * 20) / this.legendBox.clientHeight) : 0;
    },
    'curData.companyName'() {
      this.$nextTick(() => {
        this.getData();
      });
    },
    compData(n) {
      console.log(n);
    },
    tabIndex() {
      this.tableData = [];
      this.pager.currentPage = 1;
      this.refreshTable();
    },
  },
  computed: {
    dialogUlList() {
      return [
        [
          {
            label: '主体身份代码:',
            key: 'ztsfdm',
          },
          {
            label: '市场主体类型:',
            key: 'scztlx',
          },
          {
            label: '成立日期:',
            key: 'clrq',
          },
          {
            label: '登记状态:',
            key: 'djzt',
          },
          {
            label: '经营范围:',
            key: 'jyfw',
            isTip: true,
          },
        ],
        [
          {
            label: '统一社会信用代码:',
            key: 'tyxydm',
          },
          {
            label: '行业代码:',
            key: 'hydm',
          },
          {
            label: '经营期限:',
            key: 'jyqxz',
          },
          {
            label: '注册资本(金):',
            key: 'zczj',
          },
          {
            label: '住所:',
            key: 'zs',
          },
        ],
        [
          {
            label: '企业（机构）名称:',
            key: 'qymc',
          },
          {
            label: '法定代表人:',
            key: 'fddbr',
          },
          {
            label: '登记机关:',
            key: 'djjg',
          },
          {
            label: '注册资本(金)币种:',
            key: 'zczjbz',
          },
        ],
      ];
    },
    tableCompCol() {
      let col = [];
      switch (this.tabIndex) {
        case 0:
          col = [
            {
              label: '许可文件编号',
              param: 'xk_wsh',
            },
            {
              label: '许可文件名称',
              param: 'xk_xkzs',
            },
            {
              label: '有效期',
              param: 'xk_yxqzi',
            },
            {
              label: '许可机关',
              param: 'xk_xkjg',
            },
            {
              label: '许可内容',
              param: 'xk_nr',
            },
          ];
          break;
        case 1:
          col = [
            {
              label: '迁入/迁出日期',
              param: 'qrrq',
            },
            {
              label: '迁移原因',
              param: 'qeyy',
            },
            {
              label: '迁出地',
              param: 'qcdq',
            },
            {
              label: '迁入地',
              param: 'qrdq',
            },
            {
              label: '迁出登地登记机关',
              param: 'qcdjjg',
            },
            {
              label: '迁入地登记机关',
              param: 'qrdjjg',
            },
            // {
            //   label: '更新时间',
            //   param: 'f3070220000047_000148008',
            // },
          ];
          break;
        case 2:
          col = [
            {
              label: '变更日期',
              param: 'altdate',
            },
            {
              label: '变更事项',
              param: 'altitem',
            },
            {
              label: '变更前内容',
              param: 'altbe',
            },
            {
              label: '变更后内容',
              param: 'altaf',
            },
            {
              label: '变更登记机关',
              param: 'entname',
            },
          ];
          break;
        case 3:
          //   col = [
          //     {
          //       label: '年份',
          //       param: 'year',
          //     },
          //     {
          //       label: '营收总额（万元）',
          //       param: 'business_income',
          //     },
          //   ];
          //   break;
          // case 4:
          col = [
            {
              label: '列入日期',
              param: 'abntime',
            },
            {
              label: '列入经营异常原因类型',
              param: 'specause_cn',
            },
            {
              label: '列入决定机关',
              param: 'decorg_cn',
            },
            {
              label: '是否移出',
              param: 'ismove',
            },
            {
              label: '移出经营异常原因类型',
              param: 'remexcpres_cn',
            },
            {
              label: '移出日期',
              param: 'remdate',
            },
            {
              label: '移出决定机关',
              param: 'redecorg_cn',
            },
          ];
          break;
        default:
          break;
      }
      return col;
    },
  },
  methods: {
    changePage(next) {
      let { current, total } = this.pagerGD;
      if (next) {
        this.pagerGD.current = current < total ? current + 1 : current;
      } else {
        this.pagerGD.current = current > 1 ? current - 1 : current;
      }
    },
    getData() {
      // if (this.search.cityName && this.search.cityName !== '全省') dy.c_citname = this.search.cityName + '市';
      let dy = {}
      if (this.curData.uniscid) dy.uniscid = this.curData.uniscid;
      else dy.entName = this.curData.companyName
      this.$api.market
        .getEntDetail(
          dy,
          [],
          {
            showMsg: false,
          },
        )
        .then((res) => {
          this.modalData = res.data.data;
          this.compData = res.data.data.entDetail[0];
          if (this.compData) {
            this.compData.clrq = getTime(new Date(this.compData.clrq), 'yyyy-MM-dd');
            this.compData.jyqxz = getTime(new Date(this.compData.jyqxz), 'yyyy-MM-dd');
          }
          this.chart = echarts.init(document.getElementById('pie3D-gd'));
          this.loading = false;
          this.refreshTable();
          this.chartData = res.data.data.investor.map((x) => {
            let tmp = x.subconprop <= 1 ? x.subconprop * 100 : x.subconprop;
            return {
              name: x.inv,
              value: x.subconam,
              prop: tmp,
            };
          });
          this.pagerGD.total = this.chartData.length;
          while (this.chartData.length > this.colors3D.length) {
            const r = Math.floor(Math.random() * 256);
            const g = Math.floor(Math.random() * 256);
            const b = Math.floor(Math.random() * 256);
            this.colors3D.push('#' + ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1));
          }
          this.setInterData();
        });
    },
    refreshTable() {
      this.loadingTB = true;
      console.log(this.tabIndex);
      switch (this.tabIndex) {
        case 0:
          this.tableData = this.modalData.xzxk.map((x) => ({
            ...x,
            xk_yxqzi: getTime(new Date(x.xk_yxqzi), 'yyyy-MM-dd'),
          }));
          this.loadingTB = false;
          // });
          break;
        case 1:
          this.tableData = this.modalData.qrqc.map((x) => ({
            ...x,
            qrrq: getTime(new Date(x.qrrq), 'yyyy-MM-dd'),
          }));
          this.loadingTB = false;
          break;
        case 2:
          this.tableData = this.modalData.Modifyinfo.map((x) => ({
            ...x,
            altdate: getTime(new Date(x.altdate), 'yyyy-MM-dd'),
          }));
          this.loadingTB = false;
          break;
        case 3:
          this.tableData = this.modalData.abnormal.map((x) => ({
            ...x,
            abntime: getTime(new Date(x.abntime), 'yyyy-MM-dd'),
          }));
          this.loadingTB = false;
          break;

        default:
          break;
      }
    },
    handleSizeChange(e) {
      this.pager.pageSize = e;
      this.refreshTable();
    },
    handleCurrentChange(e) {
      this.pager.currentPage = e;
      this.refreshTable();
    },
    scrollList() {
      let time = 0;
      let isBottom = false;
      if (this.scrollY && this.scrollY === this.listBox.scrollHeight) {
        isBottom = true;
        this.scrollY = this.listBox.scrollHeight;
      } else if (this.scrollY < this.listBox.scrollHeight) {
        isBottom = false;
      }
      let height = isBottom ? this.scrollY - this.listBox.scrollTop : this.scrollY - this.listBox.clientHeight;
      if (isBottom && this.listBox.scrollTop) {
        let top = this.listBox.scrollTop;
        let reTime = top && String(top).length > 4 ? 0.5 : 5;
        // for (let i = top; i >= 0; i--) {
        //   setTimeout(() => {
        //     this.listBox.scrollTo(0, i);
        //   }, (top - i) * reTime)
        // }
        // setTimeout(() => {
        this.scrollY = 0;
        this.scrollList();
        // }, 10000)
      } else {
        for (let i = height; i < this.scrollY; i++) {
          time++;
          setTimeout(() => {
            this.listBox.scrollTo(0, i);
          }, time * 10);
        }
      }
      if (!isBottom) {
        this.scrollY =
          this.scrollY < this.listBox.scrollHeight ? this.scrollY + this.listBox.clientHeight : this.scrollY;
        this.scrollY =
          this.scrollY > this.listBox.scrollHeight
            ? this.listBox.scrollHeight
            : this.scrollY === this.listBox.scrollHeight
            ? 0
            : this.scrollY;

        setTimeout(() => {
          this.scrollList();
        }, time + 10000);
      }
    },

    setInterData() {
      this.$nextTick(() => {
        console.log(this.chartData, 990);
        this.$refs['pie3D-gd'].clear();
        if (this.chartData.length) this.chartOption = drawPie3D(this.chartData, 0, this.chart, this.colors3D);
        this.loadingGD = false;
      });
    },
  },
  mounted() {
    console.log(this.curData);
    this.getData();
    // this.$nextTick(() => {
    //   let listBox = $('.company-top-100 .table-list');
    //   this.listBox = listBox[0];
    // });
  },
};
</script>

<style lang="less" scoped>
.company-box {
  width: 100%;
  height: 100%;
  padding: 36px 0 42px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  .left-box {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    padding: 0 64px 0 50px;
    border-right: 2px solid #2c4c73;
    box-shadow: 1px 0px 2px 0px rgba(14, 20, 31, 0.8);
    overflow: scroll;
    &.nodata {
      border: none;
      overflow: hidden;
    }
    .company-icon {
      width: 136px;
      height: 72px;
      // margin: -18px -11px 0 -15px;
      display: inline-block;
      background: url('~img/home/company-icon.png') center center no-repeat;
      background-size: cover;
    }
  }
  .right-box {
    width: 576px;
    height: 100%;
    padding-left: 30px;
    .chart-con {
      position: relative;
    }
    .pie-bg {
      width: 100%;
      height: 100%;
      background: url('~img/home/pie-bg.png') no-repeat;
      background-size: contain;
      position: absolute;
      left: 10px;
      bottom: -70px;
      /*z-index: 2;*/
    }
    .chart-legend {
      width: 100%;
      color: #fff;
      height: 200px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      overflow: hidden;
      justify-content: center;
      max-height: 200px;
      //.show-scroll-bg-trans();

      .legend-list {
        width: 100%;
        display: flex;
        // justify-content: center;
        flex-wrap: wrap;
        height: calc(100% - 20px);
        transition: all 0.3s;
      }

      .pager-box {
        // position: absolute;
        // right: 0;
        // bottom: 10px;
        .flex-center();
        padding-right: 30px;
        font-size: 12px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #87e6ff;
        line-height: 38px;

        div {
          letter-spacing: -2px;
          margin: 0 10px;

          span {
            color: rgba(135, 230, 255, 0.3);
          }
        }

        i {
          margin-top: 2px;
          cursor: pointer;

          &.dis {
            color: rgba(135, 230, 255, 0.3);
            cursor: not-allowed;
          }
        }
      }

      .legend-item {
        width: 50%;
        padding: 0 20px;
        .flex-center();
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #dcdcdc;
        /*line-height: 20px;*/
        line-height: 30px;
        margin-bottom: 20px;
        box-sizing: border-box;

        // &:first-child {
        //   margin-top: 10px;
        // }

        .name {
          width: 100px;
          .flex-center();

          span:last-child {
            width: calc(100% - 21px);
            .ellipsis();
          }
        }
      }

      .color {
        width: 15px;
        height: 11px;
        margin-right: 6px;
      }

      .num {
        width: 80px;
        font-size: 20px;
        font-family: Geometr706 BlkCn BT;
        font-weight: 900;
        color: #fff;
        line-height: 30px;
        margin: 0 5px 0 20px;
        text-align: right;
      }

      .unit {
        font-size: 12px;
      }
    }
  }
  .left-bottom {
    display: flex;
    flex: 1;
    position: relative;
    &.nodata {
      background: url('~img/commonImg/modal-nodata.png') center center no-repeat;
      background-size: 514px 372px;
      &::before {
        position: absolute;
        bottom: 25%;
        // transform: translateY(-2%);
        content: '暂无数据!';
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #eff0f1;
        line-height: 29px;
        opacity: 0.64;
        width: 100%;
        text-align: center;
      }
    }
    /deep/.tab-list {
      margin: 0;
      .list {
        right: unset;
        left: 0;
      }
    }
    .item-wrapper {
      flex: 1;
      padding: 55px 0 0 16px;
      .item-title {
        height: 25px;
        margin-bottom: 17px;
      }
      .item-content {
      }
    }
  }
  .content-bg {
    width: 100%;
    // height: 275px;
    border-image: linear-gradient(180deg, #071322, #225087) 10 10;
    background: linear-gradient(
      90deg,
      rgba(38, 69, 103, 0.4) 0%,
      rgba(61, 110, 167, 0.4) 47%,
      rgba(38, 69, 103, 0.4) 100%
    );
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 23px 20px 31px 41px;
    > .flex-between {
      height: auto !important;
      align-items: flex-start;
    }
    ul {
      padding: 0;
      margin: 0;
      list-style: none;
      max-width: calc(100% / 3);

      + ul {
        position: relative;
        padding-left: 43px;
        &::before {
          position: absolute;
          left: 0;
          top: 0;
          width: 2px;
          height: 100%;
          background: #2c4c73;
          box-shadow: 1px 0px 2px 0px rgba(20, 34, 51, 0.5);
          content: '';
          display: inline-block;
        }
      }
      li {
        display: flex;
      }
      .li-label {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #dcdcdc;
        line-height: 30px;
        margin-right: 22px;
        text-wrap: nowrap;
      }
      .li-value {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
        line-height: 30px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
    }
    .ul-bottom {
      position: relative;
      margin-top: 17px;
      padding-top: 20px;
      display: flex;
      &::before {
        position: absolute;
        top: 0;
        width: 100%;
        height: 2px;
        background: #2c4c73;
        box-shadow: 1px 0px 2px 0px rgba(20, 34, 51, 0.5);
        content: '';
        display: block;
      }
      .li-label {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #dcdcdc;
        line-height: 30px;
        margin-right: 22px;
      }
      .li-value {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
        line-height: 30px;
      }
    }
  }
  .item-wrapper {
    .item-top {
      display: flex;
      .item-title {
        flex: 1;
      }
    }
    .item-title {
      position: relative;
      perspective: 100px;
      margin-bottom: 28px;
      &::after {
        position: absolute;
        left: 0;
        bottom: 0;
        content: attr(data-title);
        font-size: 18px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #eff0f1;
        line-height: 24px;
        padding-left: 10px;
      }
      &.YouSheTitle::after {
        font-family: 'YouSheTitle';
        font-weight: 400;
        font-size: 26px;
      }
      &::before {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 20px;
        background: linear-gradient(90deg, #328cbb 0%, rgba(50, 140, 187, 0.5) 10%, transparent 100%);
        content: '';
        display: block;
        transform: rotateX(8deg);
        perspective-origin: right top;
      }
    }
    .item-content {
      box-sizing: border-box;
    }
  }
}
</style>
